export const REGISTER = 'register';
export const PRIVACY_AGREEMENT = 'agreement';
export const TERMS_OF_USE = 'terms';
export const CONFIRM_EMAIL_URL_PART = 'confirm-email';
export const RESET_PASSWORD_URL_PART = 'reset-password';
